import React, { useState } from "react";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";
import ProdutoRepository from "../../Repositories/ProdutoRepository";
import CategoriaRepository from "../../Repositories/CategoriaRepository";
import { ICategoria } from "../../interfaces";

import { Form, Modal, InputProps, Loader, Dimmer, Label, Input, Radio, Select } from "semantic-ui-react";
import { toast } from "react-toastify";

import ModalApp from "../../components/ModalApp";
import CustomLoader from "../../components/CustomLoader";

interface State {
    codigo: string;
    nome: string;
    valor: string;
    status: number;
    categoriaId: string;
    apiErrors: IAliancaErrors;
    loading: boolean;
    open: boolean;
    categorias: ICategoria[];
}

interface Props {
    onSuccess: () => void;
}

const initialState: State = {
    codigo: "",
    nome: "",
    valor: "",
    status: 1,
    categoriaId: "",
    apiErrors: { errors: [] },
    loading: false,
    open: false,
    categorias: []
}

const CadastrarProduto: React.FC<Props> = ({ onSuccess }) => {

    const [state, setState] = useState<State>(initialState);

    const handleSubmitForm = async () => {
        try {
            setState(state => ({ ...state, loading: true }));

            const { codigo, nome, valor, status, categoriaId } = state;

            const response = await ProdutoRepository.Insert({ codigo, nome, valor: parseInt(valor), status, categoriaId });

            toast(`🎉 ${response.message}`, { position: "top-center", type: "success" });
            setState(state => ({ ...state, open: false }));
            onSuccess();

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            setState({ ...state, apiErrors: err.response.data });

            const error = errors.getApiErrors(state.apiErrors);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setState(state => ({ ...state, loading: false }));
    }

    const handleOpen = async () => {
        try {
            const response = await CategoriaRepository.List({ filter: "STATUS == 1" });
            setState({ ...initialState, categorias: response.list, open: true });
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            toast("❌ Ocorreu um erro ao carregar as categorias.");
        }
    }

    const handleClose = () => { setState({ ...state, open: false }) }

    const hasError = (key: string) => {
        return errors.hasError(state.apiErrors, key);
    }

    const getMessage = (key: string) => {
        return errors.getMessage(state.apiErrors, key);
    }

    const handleChange = (e: any, { value }: any) => setState({ ...state, status: value })

    const dropdownOptions = state.categorias.map(categoria => ({
        key: categoria.id,
        text: categoria.nome,
        value: categoria.id
    }));


    const cadastrarContent = (
        <Modal.Content scrolling>
            {state.loading &&
                <Dimmer active inverted>
                    <CustomLoader />
                </Dimmer>}
            {!state.loading &&
                <Form>
                    <Form.Field error={hasError("Codigo")} required>
                        <label>Código</label>
                        <Input
                            placeholder="Codigo"
                            value={state.codigo}
                            onChange={(e: InputProps) => setState({ ...state, codigo: e.target.value })}
                        />
                        {hasError("Codigo") && <Label pointing prompt>{getMessage("Codigo")}</Label>}
                    </Form.Field>
                    <Form.Field error={hasError("Nome")} required>
                        <label>Nome</label>
                        <Input
                            placeholder="Nome"
                            value={state.nome}
                            onChange={(e: InputProps) => setState({ ...state, nome: e.target.value })}
                        />
                        {hasError("Nome") && <Label pointing prompt>{getMessage("Nome")}</Label>}
                    </Form.Field>
                    <Form.Field error={hasError("Valor")} required>
                        <label>Valor</label>
                        <Input
                            placeholder="Valor"
                            value={state.valor}
                            onChange={(e: InputProps) => setState({ ...state, valor: e.target.value })}
                        />
                        {hasError("Valor") && <Label pointing prompt>{getMessage("Valor")}</Label>}
                    </Form.Field>
                    <Form.Field error={hasError("CategoriaId")} required>
                        <label>Categoria</label>
                        <Select
                            placeholder="Selecione..."
                            search
                            options={dropdownOptions}
                            value={state.categoriaId}
                            onChange={(e: any, { value }: any) => setState({ ...state, categoriaId: value })}
                        />
                        {hasError("CategoriaId") && <Label pointing prompt>{getMessage("CategoriaId")}</Label>}
                    </Form.Field>
                    <Form.Group inline>
                        <label>Status</label>
                        <Form.Field
                            control={Radio}
                            label="Ativo"
                            value={1}
                            checked={state.status === 1}
                            onChange={handleChange}
                        />
                        <Form.Field
                            control={Radio}
                            label="Inativo"
                            value={0}
                            checked={state.status === 0}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Form>}
        </Modal.Content>
    );

    return (
        <ModalApp
            open={state.open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Cadastrar"
            content={cadastrarContent}
            trigger={{
                icon: "add",
                color: "pink",
                content: "Novo",
                labelPosition: "left",
                floated: "right"
            }}
            onSuccess={{ content: "Salvar", func: () => handleSubmitForm() }}
        />
    );
};

export default CadastrarProduto;
